import * as PhotoSwipe from 'photoswipe';
import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import Swiper from 'swiper/js/swiper';

import helpers from './../helpers';

export default class Project {

	constructor() {
		if (document.body.classList.contains('projects')) {
			this.init();
		}
	}

	init() {
		this.initGallery();
		this.initButtonUnits();
		this.initVideos();
	}

	initGallery() {
		var projectThumb = document.querySelector(".project-thumb");
		if (projectThumb) {
			var galleryImages = JSON.parse(projectThumb.dataset.gallery);

			if (galleryImages.length > 0) {
				projectThumb.classList.add("gallery");

				var pswpElement = document.querySelector('.pswp');

				var options = {
					index: 0
				};

				var openGallery = () => {
					var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryImages, options);
					gallery.init();
				};

				projectThumb.addEventListener("click", () => {
					openGallery();
				});

				var projectThumbMobile = document.querySelector(".project-thumb-mobile");
				if(projectThumbMobile) {
					projectThumbMobile.addEventListener("click", () => {
						openGallery();
					});
				}
			}
		}
	}

	initButtonUnits() {
		let unitButton = document.querySelector(".project-middle .units-btn");
		let topNavBar = document.querySelector(".main-nav");
		if (unitButton) {
			unitButton.addEventListener("click", (event) => {
				helpers.scrollToTop(window.pageYOffset + document.querySelector("#projectUnits").getBoundingClientRect().top - topNavBar.scrollHeight, 600);
				event.preventDefault();
			});
		}
	}

	initVideos() {
		new Swiper('.swiper-container', {
			simulateTouch: false,
			touchMoveStopPropagation: true,
			passiveListeners: false,

			a11y: {
				enabled: false,
			},

			direction: 'horizontal',

			watchSlidesVisibility: true,

			slidesPerView: 1,

			breakpoints: {
				600: {
					slidesPerView: 2
				},
				800: {
					slidesPerView: 3
				},
				1000: {
					slidesPerView: 4
				}
			},

			spaceBetween: 16,

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});

		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		window.onYouTubeIframeAPIReady = () => {
			this.initVideoPopup();
		};
	}

	initVideoPopup() {
		let videoThumbs = document.querySelectorAll('.video-thumb');

		Array.from(videoThumbs).forEach((videoThumb) => {
			var player = null;
			var videoPopup = document.querySelector(videoThumb.dataset.popup);

			videoThumb.addEventListener('click', (event) => {
				event.preventDefault();

				var onPlayerReady = function (event) {
					event.target.playVideo();
				};

				if (player === null) {
					player = new window.YT.Player(videoPopup.querySelector('iframe').id, {
						events: {
							'onReady': onPlayerReady
						}
					});
				}
				else {
					player.playVideo();
				}

				videoPopup.classList.add('is-open');
				document.body.classList.add('has-popup');
			});

			videoPopup.querySelector('.video-close').addEventListener('click', function () {
				player.stopVideo();

				videoPopup.classList.remove('is-open');
				document.body.classList.remove('has-popup');
			});
		});
	}
}
